/**
 * Holds access level keys
 */
export const ACCESS_LEVELS = Object.freeze(
  {
    ADMIN: 'admin',
    FINANCE: 'finance',
    FINANCE_READONLY: 'finance-readonly',
    PUBLIC: 'public',
  },
);

export function getAccess(identity) {
  if (isAdmin(identity)) {
    return ACCESS_LEVELS.ADMIN;
  } else if (isPowerUser(identity)) {
    return ACCESS_LEVELS.FINANCE;
  } else if (isFinanceReadOnly(identity)) {
    return ACCESS_LEVELS.FINANCE_READONLY;
  }
  return ACCESS_LEVELS.PUBLIC;
}

export function isAdmin(identity) {
  return identity && identity.access === ACCESS_LEVELS.ADMIN;
}

export function isFinance(identity) {
  return identity && identity.access === ACCESS_LEVELS.FINANCE;
}

export function isPowerUser(identity) {
  return identity && (identity.access === ACCESS_LEVELS.ADMIN || identity.access === ACCESS_LEVELS.FINANCE);
}

export function isFinanceReadOnly(identity) {
  return identity && identity.access === ACCESS_LEVELS.FINANCE_READONLY;
}

export function isPublic(identity) {
  return !isPowerUser(identity) && !isFinanceReadOnly(identity);
}

export function enableBetaFeatures(identity) {
  return identity && identity.betaFeatures;
}


// WEBPACK FOOTER //
// ./src/utils/access-utils.js